import Crud from '@/views/User/Crud'
import User from '@/views/User/User'

const routes = {
  path: '/users',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/users',
      name: 'list-users',
      component: Crud,
    },
    {
      path: '/users/add',
      name: 'Usuário',
      component: User,
    },
    {
      path: '/users/edit/:id?',
      name: 'Usuário',
      component: User,
    },
  ],
}

export default routes
